export const DICT = {
  en: {
    chooseLanguage: "Choose your language",
    brandSub: "Mental health care",
    brandTag: "Official Web page",
    faculty: "Faculty",
    knowDoctor: "Know your doctor",
    knowLegalAdvisor: "Official Legal Advisor",
    mhInfo: "Mental health info",
    mhEmpty: "Helpful mental health articles will be added here soon.",
    proceedBooking: "Book an appointment",
    stepWelcome: "Welcome",
    stepDetails: "Your details",
    stepSlot: "Slot & payment",
    stepConfirm: "Confirmation",
    disclaimer: "Disclaimer",
    name: "Name",
    age: "Age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    address: "Address",
    phone: "WhatsApp number (for video / audio calls)",
    occupation: "Occupation / Educational qualification",
    helpType: "Type of help needed",
    consentTitle: "Consent",
    back: "Back",
    next: "Continue",
    required: "Please fill all the fields, choose the type of help and tick the consent box.",
    bookingTitle: "Booking your slot and payment",
    charges: "Charges for consultation",
    chooseDate: "Choose your date and time",
    noSlots: "No slots available on this day. Please choose another date.",
    pickDateFirst: "Pick a date to see available times.",
    proceedPayment: "Proceed to payment",
    slotHeld: "Your slot is held for 20 minutes while you pay.",
    changeSlot: "Change slot",
    payOnline: "Pay online",
    payOnlineSub: "UPI apps, cards or net banking - confirmed instantly",
    payUpi: "Pay directly by UPI",
    payUpiSub: "Scan the QR with your UPI app or copy the UPI ID to pay",
    upiInstructions: "Please scan the QR, or copy and paste the UPI ID into your UPI app to pay.",
    copyUpiId: "Copy UPI ID",
    upiCopied: "UPI ID copied",
    utrLabel: "UPI transaction ID (helps us confirm faster)",
    proofLabel: "Payment screenshot",
    proofPick: "Choose screenshot",
    submitPayment: "I have paid - continue",
    or: "or",
    proceedNoPayment: "Proceed without payment",
    proceedNoPaymentHint: "Your slot will be held and the doctor will see it as 'payment not done'.",
    payNow: "Pay",
    upiNotSet: "Payment details will be added by the doctor soon. Please email us to book in the meantime.",
    verifying: "Checking your payment...",
    notPaid: "Payment not completed yet. You can try again.",
    msgDoctor: "Message your doctor directly about your appointment / doubts / concerns",
    whatsapp: "WhatsApp",
    send: "Send on WhatsApp",
    sentHint: "WhatsApp opens with your booking details. Just press send there.",
    newBooking: "Book another appointment",
    paymentPending: "Payment submitted - the doctor will verify it shortly.",
    yourConfirmation: "Your confirmation",
    dearName: "Dear",
    bookingSuccessful: "Your online psychiatric consultation has been successfully booked.",
    confDoctor: "Doctor: Dr. Arun Joy, MD (Psychiatry)",
    confRegNo: "Reg No: TCMC 59977",
    confDateTime: "Date & Time",
    confVideoLink: "Video Link",
    confWhatsappChat: "WhatsApp chat with the doctor",
    confFee: "Fee",
    confPaymentMode: "Payment Mode",
    confPaymentProof: "Payment proof",
    confGstLine: "GST Status: 0% (Exempted under SAC Code 999312).",
    screenshotUploaded: "Screenshot uploaded",
    payModeUpi: "UPI/QR direct to doctor",
    payModeOnline: "Online (Cashfree)",
    payModeUpiPending: "UPI/QR direct to doctor \u00b7 status to be verified",
    payModeNotDone: "Not done yet",
    pendingReceiptNote: "Please don't worry \u2014 you will receive a digital receipt and the WhatsApp chat link after we verify your payment details.",
    unpaidInstruction: "Please complete the payment now so we can prepare the WhatsApp link and inform the doctor in advance. Once your payment is verified, you will receive the consultation link and a reminder 30-60 minutes before the session on your WhatsApp.",
    completePaymentCta: "Complete payment now",
    sessionInstructionsTitle: "Important instructions for your session:",
    sessionInstruction1: "Keep any previous medical reports or current prescriptions ready, in a quiet private room with stable internet connection.",
    sessionInstruction2: "You will receive a valid digital receipt and your prescription directly on your registered WhatsApp number after the consultation.",
    paymentNotDone: "Payment not done - the doctor will contact you.",
    paid: "Payment received",
    date: "Date",
    time: "Time",
    amount: "Amount",
    admin: "Admin",
    soundOn: "Sound on",
    soundOff: "Sound off",
    mute: "Mute",
    unmute: "Unmute",
    minutes: "min",
    chatDoctor: "Chat with doctor",
    rateTitle: "How was your booking experience?",
    rateComment: "Share a few words (optional)",
    openUpi: "Open UPI app",
    proofRequired: "A payment screenshot or UPI transaction ID is required to continue.",
    cancellationPolicy: "You can change or cancel the slot up to 6 hours before the session using your booking reference ID. Cancellations made at least 6 hours before the scheduled time will be refunded; later cancellations cannot be refunded. Sorry.",
    amountToPay: "Amount to pay",
    editMyBooking: "Complete payment / edit / cancel booking",
    editBookingTitle: "Complete payment, edit or cancel your booking",
    editBookingIntro: "Enter your booking reference ID and the WhatsApp number you booked with. Changes are allowed up to 6 hours before your session.",
    bookingRef: "Booking reference ID",
    whatsappNumber: "WhatsApp number",
    find: "Find my booking",
    reschedule: "Change date / time",
    cancelBooking: "Cancel booking",
    confirmCancel: "Are you sure you want to cancel your booking?",
    cancelled: "Your booking has been cancelled.",
    rescheduled: "Your booking has been updated.",
    tooLate: "Changes are allowed only up to 6 hours before the session.",
    finishBooking: "Finish booking",
    finishBookingHint: "This step tells the doctor your appointment is confirmed. Please complete your booking by tapping the WhatsApp button above \u2014 a message to the doctor is required to finish.",
    bookingSent: "Booking sent \u2713",
    bookingSentHint: "WhatsApp has opened in a new tab \u2014 please tap send there to complete.",
    yourConfirmation: "Your confirmation message",
    completePaymentLink: "Complete payment now",
    sessionInstructions: "Keep any previous medical reports or current prescriptions ready, in a quiet private room with stable internet connection. You will receive a valid digital receipt and your prescription directly on your registered WhatsApp number after the consultation.",
    pendingVerificationNote: "Please don't worry \u2014 you will receive the digital receipt after we verify your payment details.",
    payLaterNote: "Please complete the payment now so we can prepare the WhatsApp link and inform the doctor in advance. Once your payment is verified, you will receive the consultation link and a reminder 30-60 minutes before the session on your WhatsApp.",
  },
  ml: {
    chooseLanguage: "ഭാഷ തിരഞ്ഞെടുക്കുക",
    brandSub: "മാനസികാരോഗ്യ പരിചരണം",
    brandTag: "ഔദ്യോഗിക വെബ് പേജ്",
    faculty: "ഡോക്ടർ",
    knowDoctor: "നിങ്ങളുടെ ഡോക്ടറെ അറിയാം",
    knowLegalAdvisor: "ഔദ്യോഗിക ലീഗൽ അഡ്വൈസർ",
    mhInfo: "മാനസികാരോഗ്യ വിവരങ്ങൾ",
    mhEmpty: "ഉപകാരപ്രദമായ മാനസികാരോഗ്യ ലേഖനങ്ങൾ ഉടൻ ഇവിടെ ചേർക്കും.",
    proceedBooking: "അപ്പോയിന്റ്മെന്റ് ബുക്ക് ചെയ്യുക",
    stepWelcome: "സ്വാഗതം",
    stepDetails: "നിങ്ങളുടെ വിവരങ്ങൾ",
    stepSlot: "സമയം & പേയ്‌മെന്റ്",
    stepConfirm: "സ്ഥിരീകരണം",
    disclaimer: "ശ്രദ്ധിക്കുക",
    name: "പേര്",
    age: "വയസ്സ്",
    gender: "ലിംഗം",
    male: "പുരുഷൻ",
    female: "സ്ത്രീ",
    other: "മറ്റുള്ളവ",
    address: "വിലാസം",
    phone: "വാട്സ്ആപ്പ് നമ്പർ (വീഡിയോ / ഓഡിയോ കോളുകൾക്ക്)",
    occupation: "ജോലി / വിദ്യാഭ്യാസ യോഗ്യത",
    helpType: "ആവശ്യമായ സഹായം",
    consentTitle: "സമ്മതപത്രം",
    back: "തിരികെ",
    next: "തുടരുക",
    required: "എല്ലാ വിവരങ്ങളും പൂരിപ്പിക്കുക, സഹായത്തിന്റെ തരം തിരഞ്ഞെടുക്കുക, സമ്മതം ടിക്ക് ചെയ്യുക.",
    bookingTitle: "സമയം ബുക്ക് ചെയ്യലും പേയ്‌മെന്റും",
    charges: "കൺസൾട്ടേഷൻ ഫീസ്",
    chooseDate: "തീയതിയും സമയവും തിരഞ്ഞെടുക്കുക",
    noSlots: "ഈ ദിവസം സ്ലോട്ടുകൾ ലഭ്യമല്ല. മറ്റൊരു തീയതി തിരഞ്ഞെടുക്കുക.",
    pickDateFirst: "ലഭ്യമായ സമയം കാണാൻ ഒരു തീയതി തിരഞ്ഞെടുക്കുക.",
    proceedPayment: "പേയ്‌മെന്റിലേക്ക് പോകാം",
    slotHeld: "പണമടയ്ക്കുന്നതിനായി നിങ്ങളുടെ സ്ലോട്ട് 20 മിനിറ്റ് മാറ്റിവെച്ചിരിക്കുന്നു.",
    changeSlot: "സമയം മാറ്റുക",
    payOnline: "ഓൺലൈനായി പണമടയ്ക്കുക",
    payOnlineSub: "UPI ആപ്പുകൾ, കാർഡ് അല്ലെങ്കിൽ നെറ്റ് ബാങ്കിംഗ് - ഉടൻ സ്ഥിരീകരിക്കും",
    payUpi: "UPI വഴി നേരിട്ട് പണമടയ്ക്കുക",
    payUpiSub: "QR സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ UPI ഐഡി കോപ്പി ചെയ്ത് പണമടയ്ക്കുക",
    upiInstructions: "ദയവായി QR സ്കാൻ ചെയ്യുക, അല്ലെങ്കിൽ UPI ഐഡി കോപ്പി ചെയ്ത് നിങ്ങളുടെ UPI ആപ്പിൽ പേസ്റ്റ് ചെയ്ത് പണമടയ്ക്കുക.",
    copyUpiId: "UPI ഐഡി കോപ്പി ചെയ്യുക",
    upiCopied: "UPI ഐഡി കോപ്പി ചെയ്തു",
    utrLabel: "UPI ട്രാൻസാക്ഷൻ ഐഡി (വേഗത്തിൽ സ്ഥിരീകരിക്കാൻ സഹായിക്കും)",
    proofLabel: "പേയ്‌മെന്റ് സ്ക്രീൻഷോട്ട്",
    proofPick: "സ്ക്രീൻഷോട്ട് തിരഞ്ഞെടുക്കുക",
    submitPayment: "പണമടച്ചു - തുടരുക",
    or: "അല്ലെങ്കിൽ",
    proceedNoPayment: "പണമടയ്ക്കാതെ തുടരുക",
    proceedNoPaymentHint: "നിങ്ങളുടെ സ്ലോട്ട് റിസർവ് ചെയ്യും; 'പണമടച്ചിട്ടില്ല' എന്ന് ഡോക്ടർ കാണും.",
    payNow: "അടയ്ക്കുക",
    upiNotSet: "പേയ്‌മെന്റ് വിവരങ്ങൾ ഡോക്ടർ ഉടൻ ചേർക്കും. അതുവരെ ബുക്ക് ചെയ്യാൻ ദയവായി ഇമെയിൽ ചെയ്യുക.",
    verifying: "പേയ്‌മെന്റ് പരിശോധിക്കുന്നു...",
    notPaid: "പേയ്‌മെന്റ് പൂർത്തിയായിട്ടില്ല. വീണ്ടും ശ്രമിക്കാം.",
    msgDoctor: "നിങ്ങളുടെ അപ്പോയിന്റ്മെന്റ് / സംശയങ്ങൾ / ആശങ്കകൾ ഡോക്ടറെ നേരിട്ട് അറിയിക്കാം",
    whatsapp: "വാട്സ്ആപ്പ്",
    send: "വാട്സ്ആപ്പിൽ അയക്കുക",
    sentHint: "നിങ്ങളുടെ ബുക്കിംഗ് വിവരങ്ങളുമായി വാട്സ്ആപ്പ് തുറക്കും. അവിടെ സെൻഡ് അമർത്തുക.",
    newBooking: "മറ്റൊരു അപ്പോയിന്റ്മെന്റ് ബുക്ക് ചെയ്യുക",
    paymentPending: "പേയ്‌മെന്റ് സമർപ്പിച്ചു - ഡോക്ടർ ഉടൻ പരിശോധിക്കും.",
    yourConfirmation: "നിങ്ങളുടെ സ്ഥിരീകരണം",
    dearName: "പ്രിയ",
    bookingSuccessful: "നിങ്ങളുടെ ഓൺലൈൻ സൈക്യാട്രിക് കൺസൾട്ടേഷൻ വിജയകരമായി ബുക്ക് ചെയ്തു.",
    confDoctor: "ഡോക്ടർ: ഡോ. അരുൺ ജോയ്, MD (സൈക്യാട്രി)",
    confRegNo: "രജി. നമ്പർ: TCMC 59977",
    confDateTime: "തീയതി & സമയം",
    confVideoLink: "വീഡിയോ ലിങ്ക്",
    confWhatsappChat: "ഡോക്ടറുമായി വാട്സ്ആപ്പ് ചാറ്റ്",
    confFee: "ഫീസ്",
    confPaymentMode: "പേയ്‌മെന്റ് മോഡ്",
    confPaymentProof: "പേയ്‌മെന്റ് തെളിവ്",
    confGstLine: "ജിഎസ്ടി സ്റ്റാറ്റസ്: 0% (SAC കോഡ് 999312 പ്രകാരം ഒഴിവാക്കിയത്).",
    screenshotUploaded: "സ്ക്രീൻഷോട്ട് അപ്‌ലോഡ് ചെയ്തു",
    payModeUpi: "ഡോക്ടർക്ക് നേരിട്ട് UPI/QR",
    payModeOnline: "ഓൺലൈൻ (Cashfree)",
    payModeUpiPending: "ഡോക്ടർക്ക് നേരിട്ട് UPI/QR \u00b7 സ്ഥിരീകരിക്കേണ്ടതുണ്ട്",
    payModeNotDone: "ഇതുവരെ പണമടച്ചിട്ടില്ല",
    pendingReceiptNote: "വിഷമിക്കേണ്ടതില്ല \u2014 പേയ്‌മെന്റ് വിവരങ്ങൾ സ്ഥിരീകരിച്ച ശേഷം ഡിജിറ്റൽ രസീതും വാട്സ്ആപ്പ് ചാറ്റ് ലിങ്കും നിങ്ങൾക്ക് ലഭിക്കും.",
    unpaidInstruction: "ദയവായി ഇപ്പോൾ തന്നെ പണമടയ്ക്കുക, അപ്പോൾ നമുക്ക് വാട്സ്ആപ്പ് ലിങ്ക് തയ്യാറാക്കാനും ഡോക്ടറെ അറിയിക്കാനും സമയം ലഭിക്കും. പേയ്‌മെന്റ് സ്ഥിരീകരിച്ച ശേഷം, സെഷന് 30-60 മിനിറ്റ് മുമ്പ് കൺസൾട്ടേഷൻ ലിങ്കും ഒരു ഓർമ്മപ്പെടുത്തലും നിങ്ങളുടെ വാട്സ്ആപ്പിൽ ലഭിക്കും.",
    completePaymentCta: "ഇപ്പോൾ പണമടയ്ക്കുക",
    sessionInstructionsTitle: "നിങ്ങളുടെ സെഷനുവേണ്ടിയുള്ള പ്രധാന നിർദ്ദേശങ്ങൾ:",
    sessionInstruction1: "മുൻപത്തെ മെഡിക്കൽ റിപ്പോർട്ടുകളോ നിലവിലെ പ്രിസ്ക്രിപ്ഷനുകളോ തയ്യാറാക്കി വെക്കുക; സ്ഥിരതയുള്ള ഇന്റർനെറ്റ് ഉള്ള ശാന്തമായ സ്വകാര്യ മുറിയിൽ ഇരിക്കുക.",
    sessionInstruction2: "കൺസൾട്ടേഷന് ശേഷം സാധുവായ ഡിജിറ്റൽ രസീതും പ്രിസ്ക്രിപ്ഷനും നിങ്ങളുടെ രജിസ്റ്റേർഡ് വാട്സ്ആപ്പിൽ ലഭിക്കും.",
    paymentNotDone: "പണമടച്ചിട്ടില്ല - ഡോക്ടർ നിങ്ങളെ ബന്ധപ്പെടും.",
    paid: "പണം ലഭിച്ചു",
    date: "തീയതി",
    time: "സമയം",
    amount: "തുക",
    admin: "അഡ്മിൻ",
    soundOn: "ശബ്ദം ഓൺ",
    soundOff: "ശബ്ദം ഓഫ്",
    mute: "മ്യൂട്ട്",
    unmute: "അൺമ്യൂട്ട്",
    minutes: "മിനിറ്റ്",
    chatDoctor: "ഡോക്ടറുമായി ചാറ്റ് ചെയ്യുക",
    rateTitle: "ബുക്കിംഗ് അനുഭവം എങ്ങനെയായിരുന്നു?",
    rateComment: "അഭിപ്രായം പങ്കുവെക്കാം (നിർബന്ധമില്ല)",
    openUpi: "UPI ആപ്പ് തുറക്കുക",
    proofRequired: "തുടരുന്നതിന് പേയ്‌മെന്റ് സ്ക്രീൻഷോട്ട് അല്ലെങ്കിൽ UPI ട്രാൻസാക്ഷൻ ഐഡി ആവശ്യമാണ്.",
    cancellationPolicy: "ബുക്കിംഗ് റഫറൻസ് ഐഡി ഉപയോഗിച്ച് കൺസൾട്ടേഷന് 6 മണിക്കൂർ മുമ്പ് വരെ സ്ലോട്ട് മാറ്റാനോ റദ്ദാക്കാനോ കഴിയും. 6 മണിക്കൂറിന് മുമ്പ് റദ്ദാക്കിയാൽ തുക റീഫണ്ട് ചെയ്യും; അതിന് ശേഷമുള്ള റദ്ദാക്കൽ റീഫണ്ട് ചെയ്യാൻ കഴിയില്ല, ക്ഷമിക്കുക.",
    amountToPay: "അടയ്ക്കേണ്ട തുക",
    editMyBooking: "പേയ്‌മെന്റ് പൂർത്തിയാക്കുക / ബുക്കിംഗ് മാറ്റുക / റദ്ദാക്കുക",
    editBookingTitle: "പേയ്‌മെന്റ് പൂർത്തിയാക്കുക, ബുക്കിംഗ് മാറ്റുക അല്ലെങ്കിൽ റദ്ദാക്കുക",
    editBookingIntro: "ബുക്കിംഗ് റഫറൻസ് ഐഡിയും ബുക്ക് ചെയ്തപ്പോൾ നൽകിയ വാട്സ്ആപ്പ് നമ്പറും നൽകുക. സെഷന് 6 മണിക്കൂർ മുമ്പ് വരെ മാറ്റാം.",
    bookingRef: "ബുക്കിംഗ് റഫറൻസ് ഐഡി",
    whatsappNumber: "വാട്സ്ആപ്പ് നമ്പർ",
    find: "എന്റെ ബുക്കിംഗ് കണ്ടെത്തുക",
    reschedule: "തീയതി / സമയം മാറ്റുക",
    cancelBooking: "ബുക്കിംഗ് റദ്ദാക്കുക",
    confirmCancel: "നിങ്ങളുടെ ബുക്കിംഗ് റദ്ദാക്കണമെന്ന് ഉറപ്പാണോ?",
    cancelled: "നിങ്ങളുടെ ബുക്കിംഗ് റദ്ദാക്കി.",
    rescheduled: "നിങ്ങളുടെ ബുക്കിംഗ് അപ്‌ഡേറ്റ് ചെയ്തു.",
    tooLate: "സെഷന് 6 മണിക്കൂർ മുമ്പ് വരെ മാത്രം മാറ്റാം.",
    finishBooking: "ബുക്കിംഗ് പൂർത്തിയാക്കുക",
    finishBookingHint: "ഈ ഘട്ടമാണ് നിങ്ങളുടെ അപ്പോയിന്റ്മെന്റ് ഉറപ്പിച്ചതായി ഡോക്ടറെ അറിയിക്കുന്നത്. ദയവായി മുകളിലെ WhatsApp ബട്ടൺ അമർത്തി നിങ്ങളുടെ ബുക്കിംഗ് പൂർത്തിയാക്കൂ \u2014 ഡോക്ടർക്ക് സന്ദേശം അയയ്ക്കുന്നത് നിർബന്ധമാണ്.",
    bookingSent: "ബുക്കിംഗ് അയച്ചു \u2713",
    bookingSentHint: "പുതിയ ടാബിൽ വാട്സ്ആപ്പ് തുറന്നിട്ടുണ്ട് \u2014 അവിടെ സെൻഡ് അമർത്തുക.",
    yourConfirmation: "നിങ്ങളുടെ സ്ഥിരീകരണ സന്ദേശം",
    completePaymentLink: "ഇപ്പോൾ പണമടയ്ക്കുക",
    sessionInstructions: "മുൻപത്തെ മെഡിക്കൽ റിപ്പോർട്ടുകളോ നിലവിലെ പ്രിസ്ക്രിപ്ഷനുകളോ തയ്യാറാക്കി വെക്കുക; സ്ഥിരതയുള്ള ഇന്റർനെറ്റ് ഉള്ള ശാന്തമായ സ്വകാര്യ മുറിയിൽ ഇരിക്കുക. കൺസൾട്ടേഷന് ശേഷം സാധുവായ ഡിജിറ്റൽ രസീതും പ്രിസ്ക്രിപ്ഷനും നിങ്ങളുടെ രജിസ്റ്റേർഡ് വാട്സ്ആപ്പിൽ ലഭിക്കും.",
    pendingVerificationNote: "പേയ്‌മെന്റ് വിവരങ്ങൾ പരിശോധിച്ച ശേഷം ഡിജിറ്റൽ രസീത് ലഭിക്കും, വിഷമിക്കേണ്ടതില്ല.",
    payLaterNote: "ദയവായി ഇപ്പോൾ തന്നെ പണമടയ്ക്കുക, അപ്പോൾ നമുക്ക് വാട്സ്ആപ്പ് ലിങ്ക് തയ്യാറാക്കാനും ഡോക്ടറെ അറിയിക്കാനും സമയം ലഭിക്കും. പേയ്‌മെന്റ് സ്ഥിരീകരിച്ച ശേഷം, സെഷന് 30-60 മിനിറ്റ് മുമ്പ് കൺസൾട്ടേഷൻ ലിങ്കും ഒരു ഓർമ്മപ്പെടുത്തലും നിങ്ങളുടെ വാട്സ്ആപ്പിൽ ലഭിക്കും.",
  },
};
